// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1qoRR","text":"SelectPayment_text__2bjXr","title":"SelectPayment_title__25Ugz","btn":"SelectPayment_btn__sp6KA"};